(() => {
  function setupCategories() {
    document.querySelectorAll('.mm-category-disclosure').forEach((details) => {
      if (details.dataset.initialized) return;
      details.dataset.initialized = 'true';
      const desktop = window.matchMedia('(min-width: 1000px)');
      const sync = () => { details.open = desktop.matches; };
      sync();
      desktop.addEventListener('change', sync);
    });
  }
  document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (!group.matches?.('.mm-category-group') || !group.open) return;
    group.closest('.mm-category-links').querySelectorAll('.mm-category-group').forEach((other) => {
      if (other !== group) other.open = false;
    });
  }, true);
  setupCategories();
  document.addEventListener('shopify:section:load', setupCategories);
})();
